<template>
  <div>
    <ExpenseRequestMain
      :level="userLevel"
      :is-gold="false"
      :show-level-info="true"
      :page-config="{
        action: 'manage',
        subject: 'EXPENSEREQUESTREGULAR'
      }"
      @status-changed="handleStatusChange"
      @form-saved="handleFormSaved"
      @update:level="userLevel=$event"
    />
  </div>
</template>

<script setup lang="ts">
import ExpenseRequestMain from './ExpenseRequestMain.vue';

definePage({
  meta: {
    action: 'manage',
    subject: 'EXPENSEREQUEST',
  },
})

// 登入者資料
const userData = useStorage('userData', {}).value;

// 一般計劃的等級設定
const userLevel = ref('X'); // 一般計劃通常是X級

// 事件處理
const handleStatusChange = (status: string) => {
  console.log('一般計劃狀態變更:', status);
  // 可以根據一般計劃的需求處理狀態變更
};

const handleFormSaved = (data: any) => {
  console.log('一般計劃表單已儲存:', data);
  // 可以根據一般計劃的需求處理表單儲存
};

// 使用props中的level，如果沒有則從API獲取
const getLevel = async () => {
  try {
    const { data: getSpecialChangeLevel } = await useApi<any>(createUrl('/q/de/select/select/select/deSelect/key', {
      query: {
        tabId:'changeLevel',
        field1:userData.userno,
      },
    }));
    return getSpecialChangeLevel.value?.field2 ?? 'X';
  } catch (error) {
    console.error('獲取等級失敗:', error);
    return 'X';
  }
};

// 初始化時設定用戶等級
onMounted(async () => {
  // 可以從API獲取用戶的一般計劃等級
  userLevel.value = await getLevel();
});
</script> 